<template>
    <a-drawer width="80%" :label-col="4" :wrapper-col="14" :maskClosable="false" :visible="open" @close="onClose">
        <a-divider orientation="left">
            <b>{{ formTitle }}</b>
        </a-divider>

        <a-form-model ref="form" :model="form" :rules="rules">
            <a-form-model-item label="类型" prop="type">
                <a-select v-model="form.type" placeholder="请选择" disabled>
                    <a-select-option :value="1">为你推荐</a-select-option>
                    <a-select-option :value="2">瀑布流</a-select-option>
                </a-select>
            </a-form-model-item>

            <a-form-model-item label="语言" prop="language">
                <a-input v-model="form.language" disabled />
            </a-form-model-item>

            <!-- 短剧1 -->
            <a-form-model-item label="短剧1" prop="videoIdOne">
                <a-select :value="form.videoIdOne ? form.videoIdOne.split(',') : []" mode="multiple" showSearch
                    style="width: 100%" placeholder="请选择短剧" allow-clear optionFilterProp="children"
                    @change="val => form.videoIdOne = val.join(',')">
                    <a-select-option v-for="item in listAll" :key="item.id" :value="String(item.id)"
                        :title="item.videoName">
                        {{ item.videoName }}
                    </a-select-option>
                </a-select>
            </a-form-model-item>

            <!-- 短剧2 -->
            <a-form-model-item label="短剧2" prop="videoIdTwo">
                <a-select :value="form.videoIdTwo ? form.videoIdTwo.split(',') : []" mode="multiple" showSearch
                    style="width: 100%" placeholder="请选择短剧" allow-clear optionFilterProp="children"
                    @change="val => form.videoIdTwo = val.join(',')">
                    <a-select-option v-for="item in listAll" :key="item.id" :value="String(item.id)"
                        :title="item.videoName">
                        {{ item.videoName }}
                    </a-select-option>
                </a-select>
            </a-form-model-item>

            <!-- 短剧3 -->
            <a-form-model-item label="短剧3" prop="videoIdThree">
                <a-select :value="form.videoIdThree ? form.videoIdThree.split(',') : []" mode="multiple" showSearch
                    style="width: 100%" placeholder="请选择短剧" allow-clear optionFilterProp="children"
                    @change="val => form.videoIdThree = val.join(',')">
                    <a-select-option v-for="item in listAll" :key="item.id" :value="String(item.id)"
                        :title="item.videoName">
                        {{ item.videoName }}
                    </a-select-option>
                </a-select>
            </a-form-model-item>

            <div class="bottom-control">
                <a-space>
                    <a-button type="primary" :loading="submitLoading" @click="submitForm">
                        保存
                    </a-button>
                    <a-button type="dashed" @click="cancel">
                        取消
                    </a-button>
                </a-space>
            </div>
        </a-form-model>
    </a-drawer>
</template>
  
  
<script>
import { pitPositionDetail, editPitPosition, listVideo } from '@/api/video/video'
import Editor from '@/components/Editor'

export default {
    name: 'CreateForm',
    props: {
    },
    components: {
        Editor
    },
    data() {
        return {
            isJup: false,
            listAll: [],
            submitLoading: false,
            formTitle: '',
            // 表单参数
            form: {
                id: null,

                type: '',

                language: '',

                videoIdOne: '',

                videoIdTwo: '',

                videoIdThree: '',

                type: null,

            },
            // 1增加,2修改
            formType: 1,
            open: false,
            rules: {
            }
        }
    },
    filters: {
    },
    created() {
        this.getGather();
    },
    computed: {
    },
    watch: {
    },
    mounted() {
    },
    methods: {
        getGather() {
            listVideo({ isRelease: 1 }).then(res => {
                this.listAll = res.data;
            })
        },
        onClose() {
            this.reset();
            this.open = false
        },
        // 取消按钮
        cancel() {
            this.reset()
            this.open = false
        },
        // 表单重置
        reset() {
            this.formType = 1
            this.form = {
                id: null,
                language: '',
                videoIdOne: '',
                videoIdTwo: '',
                videoIdThree: '',
                type: null,

            }
            this.$nextTick(() => {
                if (this.$refs.form) {
                    this.$refs.form.resetFields()
                }
            })
        },
        /** 新增按钮操作 */
        handleAdd(row) {
            this.reset()
            this.formType = 1
            this.open = true
            this.formTitle = '添加'
        },
        /** 修改按钮操作 */
        handleUpdate(row, ids) {
            this.reset()
            this.formType = 2
            const id = row ? row.id : ids
            pitPositionDetail({ 'id': id }).then(response => {
                this.form = response.data
                debugger
                console.log(this.form)
                this.open = true
                this.formTitle = '修改'
            })
        },
        /** 提交按钮 */
        submitForm: function () {
            this.$refs.form.validate(valid => {
                if (valid) {
                    this.submitLoading = true
                    if (this.form.id !== undefined && this.form.id !== null) {
                        console.log('表单内容：', this.form)
                        // this.form.videoIdOne = this.form.videoIdOne.join(',')
                        // this.form.videoIdTwo = this.form.videoIdTwo.join(',')
                        // this.form.videoIdThree = this.form.videoIdThree.join(',')
                        editPitPosition(this.form).then(response => {
                            this.$message.success(
                                '修改成功',
                                3
                            )
                            this.open = false
                            this.$emit('ok')
                        }).finally(() => {
                            this.submitLoading = false
                        })
                    } else {
                        // addShare(this.form).then(response => {
                        //     this.$message.success(
                        //         '新增成功',
                        //         3
                        //     )
                        //     this.open = false
                        //     this.$emit('ok')
                        // }).finally(() => {
                        //     this.submitLoading = false
                        // })
                    }
                } else {
                    return false
                }
            })
        }
    }
}
</script>
  